import React, { useContext } from "react";
import { AuthContext } from "../AuthContext";
import axios from "axios";
import { guestbookSites, googleOAuthKey, environment } from "../../../settings/IntegrationConstants";
import { Header, HeaderContainer, T300Large } from "./SharedStyles";
import TermsPrivacy from "./TermsPrivacy";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";
import I18n from "../../../translations/i18n";

const GoogleButtonContainer = {
  style: {
    margin: "8px 0 0 0",
    display: "flex",
    justifyContent: "center"
  },
  
  'className': 'googleLoginContainer'
}

type PasswordProps = {
  firstName: string;
  onLoginClick: () => void;
  onSuccess: () => void;
}

const GoogleAuthScreen = ({firstName, onLoginClick, onSuccess }: PasswordProps) => {
  const authContext: any = useContext(AuthContext);

  const onResponseGoogle = (response: any) => {
    const submissionData = {
      google_id_token: response.credential,
    };
    axios
      .get(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/bei/google_login`,
        {
          params: submissionData,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          console.log(response)
          localStorage.setItem("gb_storage_key", response.data.user_token);
          authContext.authenticate();
        } else {
          console.log(response);
        }
      })
      .catch((error) => {
        if (error.response.data.error === "User not found.") {
          console.log("User not found!");
        } else {
          console.log(error.response.data.error);
        }
      });
    onSuccess()
  };

  return (
    <GoogleOAuthProvider clientId={googleOAuthKey}>
      <HeaderContainer>
        <Header>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.welcome_back`, {first_name: firstName})}</Header>
      </HeaderContainer>
      <GoogleLogin 
        containerProps={GoogleButtonContainer}
        onSuccess={credentialResponse => {
          onResponseGoogle(credentialResponse);
        }}
        theme="filled_blue"
        size="large"
        type="standard"  
        shape="pill"
        logo_alignment="left"
        locale="en"
        onError={() => {
          onResponseGoogle({credential: ""});
        }}
      />
      <T300Large>
        <span onClick={onLoginClick}>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.different_account`)}</span>
      </T300Large>
      <TermsPrivacy/>
    </GoogleOAuthProvider>
  );
}

export default GoogleAuthScreen